module.exports = __webpack_public_path__ + "img/moluscos.299993bb.png";